<template>
  <div class="archive">
    <AppHeader />
    <div class="filter">
      <div class="filter-container">
        <span class="breadcrumb">
          <span @click="toHome()">教研新空间</span> > 教研成果
        </span>
        <el-divider></el-divider>
        <h1 class="title">
          <img src="../assets/img/icon-champion.png" alt="" /> 教研成果
        </h1>
        <div class="search">
          <div class="tabs">
            <span class="tab-item" :class="{ active: form.type == item.value }" v-for="(item, index) in tabs"
              :key="index" @click="
                form.type = item.value;
                refresh();
              ">
              {{ item.label }}
            </span>
          </div>
          <el-input size="small" placeholder="请输入资源名称" v-model="form.name"
            @keyup.enter.native="refresh">
            <el-button slot="append" icon="el-icon-search" @click="refresh"></el-button>
          </el-input>
        </div>
        <AppCheckbox v-model="form.phaseCode" label="学段：" :list="phaseList" @change="
            form.subjectCode = '';
            getSubjectList();
            refresh();
          " />
        <AppCheckbox v-model="form.subjectCode" label="学科：" :list="subjectList" label-key="subjectName"
          value-key="subjectCode" @change="refresh" />
      </div>
    </div>
    <div class="sort">
      排序方式：
      <AppSort v-model="form.sortType.view_count" @change="viewSort">
        浏览
      </AppSort>
      <el-divider direction="vertical"></el-divider>
      <AppSort v-model="form.sortType.create_time" @change="timeSort">
        时间
      </AppSort>
      <el-divider direction="vertical"></el-divider>
      <img @click="displayType = !displayType" class="icon" :src="
          require(`../assets/img/icon-${displayType ? 'list' : 'card'}.png`)
        " alt="" />
    </div>
    <div class="list">
      <template v-if="displayType">
        <AppArchive v-for="(item, index) in archive" :key="index" :archive="item" />
      </template>
      <template v-else>
        <AppList v-for="(item, index) in archive" :key="index" :archive="item" />
      </template>
      <el-empty v-if="archive.length == 0" description="暂无课程"></el-empty>
      <el-pagination hide-on-single-page background layout="prev, pager, next" @current-change='listResource'
        :current-page.sync="page.current" :page-size="page.size" :total="page.total">
      </el-pagination>
    </div>
    <!-- <AppFoot /> -->
    <AppFoot showCopyRight showLink :showContect="false" />
  </div>
</template>
<script>
const templatePage = {
  current: 1,
  size: 12,
  total: 0,
};
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      tabs: [
        // { value: "1", label: "直播回放" },
        // { value: "2", label: "答疑专区" },
        // { value: "3", label: "专题资源" },
        { value: "4", label: "精彩回放" },
      ],
      phaseList: [
        // { label: "幼儿园", value: "01" },
        { label: "小学", value: "03" },
        { label: "初中", value: "04" },
        // { label: "高中", value: "05" },
        // { label: "特殊教育", value: "09" },
      ],
      subjectList: [],
      form: {
        type: "4",
        phaseCode: "",
        subjectCode: "",
        name: "",
        sortType: {
          view_count: "desc",
          create_time: "",
        },
      },
      page: { ...templatePage },
      displayType: true,
      archive: [],
    };
  },
  computed: {},
  created() {
    this.getlistPhase()
  },
  methods: {
    refresh() {
      this.page = { ...templatePage };
      this.listResource();
    },
    viewSort() {
      this.page = { ...templatePage };
      const { view_count, create_time } = this.form.sortType
      this.form.sortType = {
        create_time: "",
        view_count: create_time ? "desc": view_count
      }
      this.listResource();
    },
    timeSort() {
      this.page = { ...templatePage };
      const { view_count, create_time } = this.form.sortType
      this.form.sortType = {
        view_count: "",
        create_time: view_count ? "desc": create_time
      }
      // this.form.sortType.view_count = ""
      this.listResource();
    },
    toHome() {
      this.$router.push({ name: "home" });
    },
    async listResource() {
      const { view_count, create_time } = this.form.sortType
      const sortType = view_count ? `view_count:${view_count}` : create_time ? `create_time:${create_time}` : ''
      let {
        data: { rows = [], totalSize },
      } = await this.$api.res.listResource({
        pageNum: this.page.current,
        pageSize: this.page.size,
        ...this.form,
        sortType: sortType
        // sortType: `view_count:${this.form.sortType.view_count},create_time:${this.form.sortType.create_time}`,
      });
      this.archive = rows;
      this.page.total = totalSize;
    },
    async getSubjectList() {
      let { data = [] } = await this.$api.metadata.subjectList({
        phaseCode: this.form.phaseCode,
      });
      this.subjectList = data;
    },
    // 获取学段
    async getlistPhase() {
      const { data } = await this.$api.res.getlistPhase({});
      this.phaseList = data
      console.log(data);
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "archiveDetail" && to.meta.data) {
        for (let key in to.meta.data) {
          vm[key] = to.meta.data[key];
        }
      }
      vm.listResource();
      vm.getSubjectList();
    });
  },
  beforeRouteLeave(to, from, next) {
    let { page, form, displayType } = this.$data;
    from.meta.data = { page, form, displayType };
    next();
  },
};
</script>
<style scoped lang="less">
.archive {
  background: #f5f5f5;
  overflow: hidden;
  .filter {
    background: #fff;
    overflow: hidden;
    .filter-container {
      overflow: hidden;
      width: 1200px;
      margin: 0 auto 10px;
      padding-top: 20px;
      .breadcrumb {
        font-size: 14px;
        color: #606266;
        span:hover {
          color: #409eff;
          cursor: pointer;
        }
      }
      h1.title {
        display: flex;
        align-items: center;
        margin-top: 20px;
        font-size: 24px;
        font-family: MicrosoftYaHei;
        color: #262626;
        img {
          width: 36px;
          height: 36px;
          margin-right: 16px;
        }
      }
      .search {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #f0f0f0;
        border-bottom: 1px solid #f0f0f0;
        margin-top: 20px;
        .tabs {
          .tab-item {
            display: inline-block;
            height: 49px;
            white-space: nowrap;
            margin-right: 40px;
            font-size: 16px;
            font-family: MicrosoftYaHei;
            color: #262626;
            line-height: 49px;
            &.active {
              border-bottom: 2px solid #368fff;
              color: #368fff;
            }
          }
        }
        .el-input {
          width: 240px;
          height: 32px;
        }
      }
      .app-checkbox {
        margin-top: 20px;
      }
    }
    /deep/.el-input-group__append {
      padding: 0 10px;
    }
  }
  .sort {
    width: 1200px;
    margin: 20px auto 0;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #595959;
    line-height: 14px;
    .icon {
      cursor: pointer;
      position: relative;
      top: 3px;
      width: 16px;
      height: 16px;
    }
  }
  .list {
    width: 1200px;
    margin: 20px auto 0;
    .app-archive {
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
  .el-pagination {
    margin: 50px auto;
    text-align: center;
  }
}
</style>